import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SharedModule } from '../shared.module';
import { RouterModule } from '@angular/router';

export interface IAlarmToastData {
  type: string;
  deviceId: string;
  parameter?: string;
  routerLinkUrl: string;
}

@Component({
    standalone: true,
    templateUrl: 'alarm-notification-popup.html',
    styleUrls: ['alarm-notification-popup.css'],
    encapsulation: ViewEncapsulation.None,
    imports: [SharedModule, RouterModule]
})

export class alarmNotificationPopupComponent {
    constructor(
        public snackBarRef: MatSnackBarRef<alarmNotificationPopupComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: IAlarmToastData,
    ) {}

    dismiss(): void {
        this.snackBarRef.dismiss();
    }
}
